import { notification } from 'antd';

function IMessage(ownNotification) {
  return {
    error: (...args) => {
      ownNotification.destroy();
      ownNotification.error({
        message: args[0],
        duration: args[1],
        onClose: args[2],
      });
    },
    success: (...args) => {
      ownNotification.destroy();
      ownNotification.success({
        message: args[0],
        duration: args[1],
        onClose: args[2],
      });
    },
    warning: (...args) => {
      ownNotification.destroy();
      ownNotification.warning({
        message: args[0],
        duration: args[1],
        onClose: args[2],
      });
    },
  };
}

export default IMessage(notification);
